export const TrackingForms = {
  CHECKOUT: 'booking_checkout_form'
}

const EVENTS = [
  'change',
  'focus',
  'click',
  'paste',
  'keydown'
]

let abandonData = {}

function buildAbandonData ({ id, name }) {
  abandonData = {
    formAbandonmentField: name || id,
    formName: TrackingForms.CHECKOUT
  }
}

const trackAbandon = (eventData) => {
  global.TrackingService.track(global.TrackingService.eventBuilder(global.trackingEvents.FORM_ABANDONMENT, eventData))
}

window.addEventListener('beforeunload', function () {
  if (hasAbandonTheForm && abandonData.formAbandonmentField) {
    trackAbandon(abandonData)
  }
})

export let hasAbandonTheForm = true

export const setHasAbandonTheForm = (value) => {
  hasAbandonTheForm = value
}

export default {
  bind (el, binding, node) {
    if (global.$(el).is('select')) {
      global.$(el).on('select2:selecting', function () {
        buildAbandonData(el)
      })
    }
    EVENTS.forEach(event => {
      el.addEventListener(event, function () {
        if ((global.Utils.isChrome() && !global.$(el).is(':-webkit-autofill')) || !global.Utils.isChrome()) {
          buildAbandonData(el)
        }
      })
    })
  }
}
